export const MenuOptions = [
  "Sponsor",
  "Programma",
  "Evidenza",
  "Aree",
  "Food",
  "Tornei",
  "Faq",
];
